<ng-template>
  <div
    (click)="onContentClick($event)"
    class="tw-flex tw-shrink-0 tw-flex-col tw-rounded-xl tw-border tw-border-solid tw-border-border-light tw-bg-bg-primary tw-shadow-lg tw-bg-clip-padding tw-overflow-y-auto"
    [attr.role]="ariaRole()"
    [attr.aria-label]="ariaLabel()"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="ariaRole() === 'dialog'"
    tabindex="-1"
  >
    <div role="none" class="tw-p-2 tw-flex tw-flex-col tw-gap-1">
      <ng-content></ng-content>
    </div>
    <div
      role="none"
      class="tw-p-2 tw-border-0 tw-border-t tw-border-solid tw-border-border-base empty:tw-hidden"
    >
      <ng-content select="[slot=footer]"></ng-content>
    </div>
  </div>
</ng-template>
